"use client";

import { createContext, use } from "react";

// Lets a tool page's server part hand ToolShell extra, server-rendered content
// (questions, related tools) without passing it through every tool component.
const ExtrasContext = createContext<React.ReactNode>(null);

export function ToolExtras({
  extras,
  children,
}: {
  extras: React.ReactNode;
  children: React.ReactNode;
}) {
  return <ExtrasContext value={extras}>{children}</ExtrasContext>;
}

/** The extras for the tool page being shown (null outside a ToolPage). */
export function useToolExtras() {
  return use(ExtrasContext);
}
